import { createStyles } from '@material-ui/core';
var styles = function (theme) {
    return createStyles({
        tooltip: {
            background: theme.palette.background.tooltip,
            boxShadow: theme.shadows[4],
            color: theme.palette.common.white,
            maxWidth: 'auto',
        },
        arrow: {
            color: theme.palette.background.tooltip,
        },
    });
};
export default styles;
